import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'it',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    it: {
      translations: require('./locales/it/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'it'];

export default i18n;